import { render, staticRenderFns } from "./TrialStepOs.vue?vue&type=template&id=172e88df&"
import script from "./TrialStepOs.vue?vue&type=script&lang=ts&"
export * from "./TrialStepOs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('172e88df')) {
      api.createRecord('172e88df', component.options)
    } else {
      api.reload('172e88df', component.options)
    }
    module.hot.accept("./TrialStepOs.vue?vue&type=template&id=172e88df&", function () {
      api.rerender('172e88df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/trial/TrialStepOs.vue"
export default component.exports